import ChartSection from './ChartSection'

export default ChartSection
